export default __webpack_public_path__ + "static/media/banner_login.b19f4b27.jpg";